import { getAllCategoryNamesAndSlugs2 } from '@api';
import { GetStaticPaths } from 'next';
export { default, getStaticProps } from './page/[pageNo]';
import { getHnaviContentCategoriesFromCategories } from '@helpers';

export const getStaticPaths: GetStaticPaths<{
  hnaviCategory: string;
}> = async () => {
  const hnaviContentCategories = getHnaviContentCategoriesFromCategories(
    await getAllCategoryNamesAndSlugs2()
  );

  return {
    paths: Object.keys(hnaviContentCategories).map((hnaviCategory) => ({
      params: { hnaviCategory },
    })),
    fallback: 'blocking',
  };
};
